"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionProvider = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@connect2ic/core");
const providers_1 = require("@connect2ic/core/providers");
const react_2 = require("@connect2ic/react");
const ogy_governance_canister_did_1 = require("./candid/ogy_governance_canister.did");
const ledger_did_1 = require("./candid/ledger.did");
const ogy_vesting_canister_did_1 = require("./candid/ogy_vesting_canister.did");
const SessionProvider = ({ children }) => {
    // const [dev, setDev] = useState(isLocal() && localDevelopment);
    return (react_1.default.createElement(react_2.Connect2ICProvider, { client: (0, core_1.createClient)({
            canisters: {
                governance: {
                    canisterId: process.env.GOVERNANCE_CANISTER_ID,
                    idlFactory: ogy_governance_canister_did_1.idlFactory,
                },
                vesting: {
                    canisterId: process.env.VESTING_CANISTER_ID,
                    idlFactory: ogy_vesting_canister_did_1.idlFactory,
                },
                ledger: {
                    canisterId: process.env.LEDGER_CANISTER_ID,
                    idlFactory: ledger_did_1.idlFactory,
                },
                icpLedger: {
                    canisterId: "ryjl3-tyaaa-aaaaa-aaaba-cai",
                    idlFactory: ledger_did_1.idlFactory,
                }
            },
            providers: providers_1.defaultProviders,
            globalProviderConfig: {
                dev: false,
                host: 'https://icp-api.io',
                whitelist: [process.env.GOVERNANCE_CANISTER_ID, process.env.VESTING_CANISTER_ID, process.env.LEDGER_CANISTER_ID],
            },
        }) }, children));
};
exports.SessionProvider = SessionProvider;
